import { supabase } from '../lib/supabase';
import type { Node, Connection, PostIt } from '../types';

interface ShareMapParams {
  nodes: Node[];
  connections: Connection[];
  postIts?: PostIt[];
  mapName?: string;
}

export const shareMap = async ({ nodes, connections, postIts, mapName }: ShareMapParams): Promise<string> => {
  const { data, error } = await supabase
    .from('shared_maps')
    .insert({
      map_name: mapName || 'Mappa senza nome',
      map_data: { nodes, connections, postIts: postIts || [] },
    })
    .select('id')
    .single();

  if (error) throw error;
  return data.id;
};

export const getSharedMap = async (id: string) => {
  const { data, error } = await supabase
    .from('shared_maps')
    .select('map_name, map_data, created_at')
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
};
